import {
    getLocationFromNavigator,
    EXTENDED_GEOLOCATION_POSITION_ERROR_MAP,
    STATUS_ENUM,
} from '@/utils/geo'

export default {
    async getPosition({ commit, getters }) {
        let position
        try {
            position = await getLocationFromNavigator()
        } catch (e) {
            // get readable value from numerical code
            const errorValue = EXTENDED_GEOLOCATION_POSITION_ERROR_MAP[e.code]
            const status = getters.acquired ? STATUS_ENUM.LAST_KNOWN : STATUS_ENUM.NONE
            commit('set', {
                error: errorValue,
                status: status,
            })
            return false
        }
        const time = new Date(position.timestamp).toISOString()
        commit('set', {
            lat: position.coords.latitude,
            long: position.coords.longitude,
            accuracy: position.coords.accuracy,
            time: time,
            error: null,
            status: STATUS_ENUM.CURRENT,
        })
        return true
    },
}
